export class Aplicacion {
    id_aplicacion: number;
    txt_descripcion: string;
    txt_clave: string;
    ind_update: 0;
    ind_estado: number;
    num_sesiones: number;
    menu = []
}